import {Component, OnInit, ViewChild} from '@angular/core';
import swal from 'sweetalert2';
import {prepareObject} from '../../../services/utilities';
import {base_urls} from '../../../config/base_urls';
import {Endpoints} from '../../../config/endpoints';
import {ActivatedRoute} from '@angular/router';
import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {Title} from '@angular/platform-browser';
import {TitleBroadcastService} from '../../../services/title-broadcast.service';
import {interval, of, ReplaySubject, Subject} from 'rxjs';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import {MatPaginator, MatSelectChange, MatSort} from '@angular/material';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import * as moment from 'moment';
import {DatePipe} from '@angular/common';
import {debounceTime, switchMap} from 'rxjs/operators';
import {catchError, takeUntil} from 'rxjs/internal/operators';
import {User} from '../../../models/user';
import {FormControl} from '@angular/forms';
import {Market} from '../../../models/market';
import {MarketLevel} from '../../../models/market-level';
import {MarketService} from '../../../services/market-service';

@Component({
  selector: 'app-all-user-timeline-by-date-range',
  templateUrl: './all-user-timeline-by-date-range.component.html',
  styleUrls: ['./all-user-timeline-by-date-range.component.scss']
})
export class AllUserTimelineByDateRangeComponent implements OnInit {

    filters = {
        'userId': null,
        'fromDate': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        'toDate': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        fileType: null,
        marketId: null,
    };

    marketLevels: MarketLevel[] = [];
    markets = [];
    selectedMarket: Market[] = [];
    userRank: number;
    marketFilterForm: FormControl = new FormControl();
    filteredMarketList = [];
    marketIndex = 0;

    fromDate = moment();
    toDate = moment();
    moment = moment;
    calendarLocale: LocaleConfig;
    ranges: any;
    selectedRange: any = {startDate: null, endDate: null};
    datePipe = new DatePipe('en-US');
    isCalenderOpen = false;

    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    userType = 'ORGANIZATION_USER';

    requestId = null;

    progress = 0;
    stopPolling$ = new Subject();
    fileUrl = null;
    exportFailed = false;
    statusMsg = null;

    @ViewChild(DaterangepickerDirective) dateRangePicker: DaterangepickerDirective;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    private _unsubscribeAll: Subject<any>;

    constructor( private marketService: MarketService, private route: ActivatedRoute, private service: BaseService, private auth: AuthService, private titleService: Title, private titleBroadcastService: TitleBroadcastService) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('All User Timeline By Date Range');

        this.marketLevels = marketService.marketLevels;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.levelRank] = [];
            this.selectedMarket[pMarketLevel.levelRank] = null;
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = marketService.userRank;
        this.selectedMarket = this.marketService.prepareUserMarket();
        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };

        this.ranges = {
            'Today': [moment(), moment()],
            'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
            'This Month': [moment().startOf('month'), moment().endOf('month')],
            'Last Month': [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month'),
            ],
        };

        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');
        this.selectedRange.endDate = moment().subtract(0, 'days').startOf('day');
    }

    ngOnInit() {
        this._getUserList();
        this.userFilter.valueChanges.pipe(debounceTime(500), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.UserName.toLowerCase().indexOf(search.toLowerCase()) > -1
            ));
        });

        this.loadInitialMarkets();
        this.marketFilterForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.markets[this.marketIndex]) {
                return;
            }

            const search = this.marketFilterForm.value;
            if (!search) {
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
                return;
            }
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].filter(product => product.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

    }

    loadInitialMarkets(): void {
        this.marketService.getInitialMarketList().subscribe(responses => {
            responses.forEach((pResponse, index) => {
                const pMarketLevel = this.marketLevels[index];
                this.markets[pMarketLevel.Rank] = pResponse;
                this.filteredMarketList[index].next(this.markets[pMarketLevel.Rank].slice());
            });
        });
    }

    marketFilterChangeListener(pEvent: MatSelectChange): void {
        this.marketService.marketChangeListener(pEvent, this.marketIndex, this.selectedMarket).subscribe(pResponse => {
            this.selectedMarket = pResponse;
        });
    }

    getSelectedLevelMarkets(marketLevel: MarketLevel): void {
        this.marketIndex = marketLevel.Rank;
        this.marketService.getSelectedLevelMarkets(marketLevel, this.selectedMarket).subscribe(pResponse => {
            this.markets[this.marketIndex] = pResponse;
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
        });
    }

    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.id == pMarket2.Id;
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseSize: 'MINIFY',
            UserType: this.userType,
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        }).subscribe(userList => {
            this.userList = userList;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    dateChangeListener(pEvent: any): void {
        this.filters.fromDate = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.filters.toDate = this.datePipe.transform(this.selectedRange.endDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
    }

    openProgressModal(): void {
        this.progress = 0;
        this.exportFailed = false;
        this.fileUrl = null;
        const modal = document.getElementById('progressModal');
        modal.style.display = 'block';
    }

    closeProgressModal(): void {
        const modal = document.getElementById('progressModal');
        modal.style.display = 'none';
    }

    startPollingStatus(): void {
        this.progress = 0;
        this.exportFailed = false;
        const polling = interval(2000)
            .pipe(
                switchMap(() => this.service.generateExportStatus(this.requestId, base_urls.f_base))
            )
            .subscribe((res: any) => {
                if (res.progressPercentage !== undefined) {
                    this.progress = res.progressPercentage;
                }
                this.statusMsg = res.message;
                if (res.success === false) {
                    this.exportFailed = true;
                    polling.unsubscribe();
                }
                this.fileUrl = res.fileUrl;

                if (res.fileUrl) {
                    polling.unsubscribe();
                }
            });
    }


    downloadReport(): void {
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '<div class="col-md-12">' +

                '<div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="XLSX" id="input1" name="filetype" checked> XLSX' +
                '<input class="col-xs-4 col-xs-offset-4" name="filetype" type="radio" value="CSV" id="input2" style="margin-left: 20px;"> CSV ' +
                '</div>\n' +
                '</div><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                swal.disableConfirmButton();
                const isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;

                const isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;

                const fileName = (<HTMLInputElement>document.getElementById('report')).value;
                let fileType;
                if (isSelected) {
                    fileType = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (isSelected1) {
                    fileType = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                const request = prepareObject(this.filters);
                const exportRequest = {
                    downloadFileName: fileName ? fileName : 'All User Timeline By Date Range',
                    fileType: fileType
                };
                const combinedRequest = {...request, ...exportRequest};
                this.service.generateAsyncGetUrlForMicroservice(base_urls.hrws + Endpoints.export_all_user_timeline_by_date_range, combinedRequest, fileName, false).subscribe(
                    data => {
                        this.requestId = data.requestId;
                        if (this.requestId) {
                            this.openProgressModal();
                            this.progress = 0;
                            this.exportFailed = false;
                            this.fileUrl = null;
                            this.startPollingStatus();
                        }
                    });
            },

            allowOutsideClick: () => !swal.isLoading()
        });
    }


}
